import navbar from "../../translation/navbar/ge/navbar.json";
import navbarHeader from "../../translation/navBarHeader/ge/navbarHeader.json";
import packs from "../../translation/packs/ge/packs.json";
import billingSlider from "../../translation/billingSlider/ge/billingSlider.json";
import pricingCard from "../../translation/pricingCard/ge/pricingCard.json";
import compatibleProgramsSection from "../../translation/compatibleProgramsSection/ge/compatibleProgramsSection.json";
import reviews from "../../translation/reviews/ge/reviews.json";
import faq from "../../translation/faq/ge/faq.json";
import contactForm from "../../translation/contactForm/ge/contactForm.json";
import freeTrial from "../../translation/freeTrial/ge/freeTrial.json";
import dahsboardLogin from "../../translation/dashboardLogin/ge/dashboardLogin.json";
import userSetting from "../../translation/userSetting/ge/userSetting.json";
import dashboard from "../../translation/dashboard/ge/dashboard.json";
import accountSetting from "../../translation/accountSetting/ge/accountSetting.json";
import clients from "../../translation/clients/ge/clients.json";
import navbarAdmin from "../../translation/navbarAdmin/ge/navbarAdmin.json";
import termsAndCondition from "../../translation/termsAndConditions/ge/termsAndConditions.json";
import footer from "../../translation/footer/ge/footer.json";
import helpPage from "../../translation/helpPage/ge/helpPage.json";
import cookiePopup from "../../translation/cookiePopup/ge/cookiePopup.json";
import InvoiceForm from "../../translation/InvoiceForm/ge/InvoiceForm.json";
import InfoBill from "../../translation/InfoBill/ge/InfoBill.json";
import InfoContact from "../../translation/InfoContact/ge/InfoContact.json";
import Preview from "../../translation/Preview/ge/Preview.json";
import Contacts from "../../translation/Contacts/ge/Contacts.json";
import Assets from "../../translation/Assets/ge/Assets.json";
import Transctions from "../../translation/Transctions/ge/Transctions.json";
import ChatView from "../../translation/ChatView/ge/ChatView.json";
import ArticlesTransactions from "../../translation/ArticlesTransactions/ge/ArticlesTransactions.json";
import PanelTemplate from "../../translation/PanelTemplate/ge/PanelTemplate.json";
import Automate from "../../translation/Automate/ge/Automate.json";
import Panelautomate from "../../translation/Panelautomate/ge/Panelautomate.json";
import AutomatesComponent from "../../translation/AutomatesComponent/ge/AutomatesComponent.json";
import Landing from "../../translation/Landing/ge/Landing.json";
export default {
  navbar,
  navbarHeader,
  Landing,
  packs,
  billingSlider,
  pricingCard,
  compatibleProgramsSection,
  reviews,
  faq,
  contactForm,
  freeTrial,
  dahsboardLogin,
  userSetting,
  dashboard,
  accountSetting,
  clients,
  navbarAdmin,
  termsAndCondition,
  footer,
  helpPage,
  cookiePopup,
  InvoiceForm,
  InfoBill,
  InfoContact,
  Preview,
  Contacts,
  Assets,
  Transctions,
  ChatView,
  ArticlesTransactions,
  PanelTemplate,
  Automate,
  Panelautomate,
  AutomatesComponent,
};
